import {getMethod} from '@/api'

async function get(params) {
    return await getMethod('/api/voucher', params, null, {responseType: 'arraybuffer'})
}

export {get}
